export default __webpack_public_path__ + "static/media/survey-icon.c22c43c6.svg";